import { render, staticRenderFns } from "./CustomerSales.vue?vue&type=template&id=a66d82ec&"
import script from "./CustomerSales.vue?vue&type=script&lang=js&"
export * from "./CustomerSales.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSales.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports